import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MaterialModule } from '../material/material.module';
import { FileService } from '../services/api/file.service';
import { NotificationsService } from '../services/notifications/notifications.service';
import { SharedModule } from '../shared/shared.module';
import { BibliaToExportComponent } from './biblia/biblia-to-export/biblia-to-export.component';
import { BibliaComponent } from './biblia/biblia.component';
import { DialogEditComponent } from './biblia/dialog-edit/dialog-edit.component';
import { DialogRevisionACComponent } from './biblia/dialog-revisionAC/dialog-revisionAC.component';
import { DialogServiceHistorialComponent } from './biblia/dialog-service-historial/dialog-service-historial.component';
import { DialogServiciosListComponent } from './biblia/dialog-servicios-list/dialog-servicios-list.component';
import { PasajerosDialogComponent } from './biblia/pasajeros-dialog/pasajeros-dialog.component';
import { VuelosDialogComponent } from './biblia/vuelos-dialog/vuelos-dialog.component';
import { FileRoutingModule } from './file-routing.module';
import { FileComponent } from './file.component';
import { DetailEntradasComponent } from 'src/pages/detail-entradas/detail-entradas.component';
// import { MassServiceOrdersComponent } from 'src/pages/mass-service-orders/mass-service-orders.component'; // ANTIGUO OS / OP masivas (reemplazado por os-masivas / np-masivas)
import { OrdersReportComponent } from 'src/pages/orders-report/orders-report.component';
import { ReservationsReportComponent } from 'src/pages/reservations-report/reservations-report.component';
import { ReporteFileComponent } from './reporte-file/reporte-file.component';
import { ServicesComponent } from './services/services.component';
import { DetalleComponent } from './ticketeria/detalle/detalle.component';
import { TicketsTableExpandModule } from './ticketeria/table-expand/tickets-table-expand.module';
import { TicketeriaComponent } from './ticketeria/ticketeria.component';
import { FileProgrammingComponent } from 'src/pages/file-programming/file-programming.component';
import { FileProgrammingFiltersComponent } from 'src/widgets/file-programming-filters/file-programming-filters.component';
import { FileProgrammingHeaderComponent } from 'src/widgets/file-programming-header/file-programming-header.component';
import { FileProgrammingLegendComponent } from 'src/widgets/file-programming-legend/file-programming-legend.component';
import { FileProgrammingTableComponent } from 'src/widgets/file-programming-table/file-programming-table.component';
import { MassOsHeaderComponent } from 'src/widgets/mass-os-header/mass-os-header.component';
import { MassOsFiltersComponent } from 'src/widgets/mass-os-filters/mass-os-filters.component';
import { MassOsServicesTableComponent } from 'src/widgets/mass-os-services-table/mass-os-services-table.component';
import { MassOsGenerationComponent } from 'src/pages/mass-os-generation/mass-os-generation.component';
import { MassOsStepperComponent } from 'src/widgets/mass-os-stepper/mass-os-stepper.component';
import { MassOsProviderPeriodComponent } from 'src/widgets/mass-os-provider-period/mass-os-provider-period.component';
import { MassOsClientComponent } from 'src/widgets/mass-os-client/mass-os-client.component';
import { MassOsServiceTypesComponent } from 'src/widgets/mass-os-service-types/mass-os-service-types.component';
import { MassOsReviewSummaryComponent } from 'src/widgets/mass-os-review-summary/mass-os-review-summary.component';
import { MassOsItinerariesTableComponent } from 'src/widgets/mass-os-itineraries-table/mass-os-itineraries-table.component';
import { MassOsItineraryServicesComponent } from 'src/widgets/mass-os-itinerary-services/mass-os-itinerary-services.component';
import { MassOsItineraryServicesSyncComponent } from 'src/widgets/mass-os-itinerary-services-sync/mass-os-itinerary-services-sync.component';
import { MassOsTicketExpandComponent } from 'src/widgets/mass-os-ticket-expand/mass-os-ticket-expand.component';
import { MassOsItinerarySyncCardComponent } from 'src/widgets/mass-os-itinerary-sync-card/mass-os-itinerary-sync-card.component';
import { DialogSyncPaymentDateComponent } from 'src/pages/mass-os-generation/dialogs/dialog-sync-payment-date/dialog-sync-payment-date.component';
import { OrdersReportHeaderComponent } from 'src/widgets/orders-report-header/orders-report-header.component';
import { OrdersReportFiltersComponent } from 'src/widgets/orders-report-filters/orders-report-filters.component';
import { OrdersReportTableComponent } from 'src/widgets/orders-report-table/orders-report-table.component';
import { ReservationsReportHeaderComponent } from 'src/widgets/reservations-report-header/reservations-report-header.component';
import { ReservationsReportFiltersComponent } from 'src/widgets/reservations-report-filters/reservations-report-filters.component';
import { ReservationsReportTableComponent } from 'src/widgets/reservations-report-table/reservations-report-table.component';
import { DetailFileSummaryModule } from 'src/widgets/detail-file-summary/detail-file-summary.module';
import { ServiceOrderActionsModule } from 'src/features/service-order/services-os-actions/services-os-actions.module';
import { OrderPdfModule } from 'src/features/service-order/order-pdf/order-pdf.module';
import { TicketsStatusLegendModule } from 'src/widgets/tickets-status-legend/tickets-status-legend.component';

@NgModule({
  declarations: [
    FileComponent,
    FileProgrammingComponent,
    FileProgrammingHeaderComponent,
    FileProgrammingFiltersComponent,
    FileProgrammingLegendComponent,
    FileProgrammingTableComponent,
    MassOsHeaderComponent,
    MassOsFiltersComponent,
    MassOsServicesTableComponent,
    MassOsGenerationComponent,
    MassOsStepperComponent,
    MassOsProviderPeriodComponent,
    MassOsClientComponent,
    MassOsServiceTypesComponent,
    MassOsReviewSummaryComponent,
    MassOsItinerariesTableComponent,
    MassOsItineraryServicesComponent,
    MassOsItineraryServicesSyncComponent,
    MassOsItinerarySyncCardComponent,
    MassOsTicketExpandComponent,
    DialogSyncPaymentDateComponent,
    OrdersReportHeaderComponent,
    OrdersReportFiltersComponent,
    OrdersReportTableComponent,
    OrdersReportComponent,
    ReservationsReportHeaderComponent,
    ReservationsReportFiltersComponent,
    ReservationsReportTableComponent,
    ReservationsReportComponent,
    BibliaComponent,
    ServicesComponent,
    PasajerosDialogComponent,
    // MassServiceOrdersComponent, // ANTIGUO OS / OP masivas (reemplazado por os-masivas / np-masivas)
    DialogServiciosListComponent,
    DialogRevisionACComponent,
    BibliaToExportComponent,
    DialogEditComponent,
    DialogServiceHistorialComponent,
    VuelosDialogComponent,
    DetailEntradasComponent,
    TicketeriaComponent,
    ReporteFileComponent,
    DetalleComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    SharedModule,
    MatSortModule,
    BrowserModule,
    MatInputModule,
    MaterialModule,
    MatDialogModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule,
    TablerIconsModule,
    FileRoutingModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatTableExporterModule,
    ScrollingModule,
    ServiceOrderActionsModule,
    OrderPdfModule,
    DetailFileSummaryModule,
    TicketsTableExpandModule,
    TicketsStatusLegendModule
  ],
  providers: [FileService, NotificationsService]
})
export class FileModule {}
